import * as React from 'react';
import { getSelectedProject, getSelectedProjectId, loadProject } from 'owa-timestream-store';
import { Interstitial } from 'owa-timestream-loadingpanel';
import { observer } from 'mobx-react-lite';
import { useCanvasConfig } from '../hooks/useCanvasConfig';

export default observer(function TimeStreamCanvasInterstitial({
    children,
}: {
    children: JSX.Element;
}) {
    const config = useCanvasConfig();
    const { loaded, loadingFailed } = getSelectedProject();

    React.useEffect(reload, []);

    return (
        <Interstitial
            succeeded={loaded}
            failed={loadingFailed}
            errorMessage={config.getLoadingAssetsFailedMessage()}
            onRetry={reload}>
            {children}
        </Interstitial>
    );
});

function reload() {
    loadProject(getSelectedProjectId());
}
